import React from "react";
import { useTranslation } from "react-i18next";
import { indexStore } from "src/store/indexStore";
import EditCategoryModel from "../pages/categories/EditCategoryModel";
import { AlertDialogs } from "../Dialgos/Alter-Daylogs";
import { Skeleton } from "../ui/skeleton";
import Visibility from "../utils/Visibility";
import { userTypes } from "src/enums/usersTpes";
import { Card, CardContent, CardHeader } from "../ui/card";
import { Button } from "../ui/button";
import { Edit, Trash2, FolderTree, UtensilsCrossed } from "lucide-react";
import { Badge } from "../ui/badge";

export function CategoryCard(props) {
  const { t } = useTranslation();
  const { deleteCategoryAction, setCategory, menus, nameLang } = indexStore();
  
  const onDeleteMenu = (id) => {
    deleteCategoryAction(id);
  };
  
  const editCategory = (element) => {
    setCategory(element);
  };
  
  const menu =
    menus &&
    menus.length > 0 &&
    menus.filter((menu) => menu.id == props.section_id)[0];

  return (
    <Card className="group hover:shadow-xl transition-all duration-300 overflow-hidden border-2 hover:border-primary/20">
      <CardHeader className="pb-3 pt-6 px-6 bg-gradient-to-br from-primary/10 to-transparent border-b">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-primary/20">
            <FolderTree className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-bold text-foreground line-clamp-2">
              {props[nameLang] || t("gloabl.category")}
            </h3>
          </div>
        </div>
      </CardHeader>

      <CardContent className="p-6 pt-4">
        {menu && (
          <div className="mb-4 p-3 bg-muted/50 rounded-lg border">
            <div className="flex items-center gap-2">
              <UtensilsCrossed className="w-4 h-4 text-muted-foreground" />
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground mb-1">
                  {t("gloabl.menu")}
                </p>
                <p className="font-medium text-sm line-clamp-1">
                  {menu[nameLang] || "-"}
                </p>
              </div>
            </div>
          </div>
        )}

        <Visibility
          visible={
            localStorage.getItem("role") === userTypes.ADMIN ||
            localStorage.getItem("role") === userTypes.DATAMANAGER
          }
        >
          <div className="flex gap-2 pt-4 border-t">
            <EditCategoryModel
              trigger={
                <Button
                  variant="outline"
                  size="sm"
                  className="flex-1 gap-2"
                  onClick={() => editCategory(props)}
                >
                  <Edit className="w-4 h-4" />
                  {t("gloabl.edit")}
                </Button>
              }
            />
            <AlertDialogs
              trigger={
                <Button
                  variant="destructive"
                  size="sm"
                  className="gap-2"
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              }
              variant="icon"
              onClickOk={() => onDeleteMenu(props.id)}
              description={<span>{t("gloabl.deleteMessage")}</span>}
              title={`${t("gloabl.delete")} ${t("gloabl.category")}`}
            />
          </div>
        </Visibility>
      </CardContent>
    </Card>
  );
}

export const CategoryCardLoading = () => (
  <Card className="overflow-hidden border-2">
    <CardHeader className="pb-3 pt-6 px-6 bg-gradient-to-br from-primary/10 to-transparent border-b">
      <div className="flex items-center gap-3">
        <Skeleton className="w-9 h-9 rounded-lg" />
        <Skeleton className="h-5 flex-1" />
      </div>
    </CardHeader>
    <CardContent className="p-6 pt-4">
      <Skeleton className="w-full h-20 rounded-lg mb-4" />
      <div className="flex gap-2 pt-4 border-t">
        <Skeleton className="h-9 flex-1" />
        <Skeleton className="w-9 h-9" />
      </div>
    </CardContent>
  </Card>
);
